/**
 * @author Ketan Shetye
 * @created 2025-11-24
 * @description client admin janus routing
 */

import {
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Routes
} from '@angular/router';
import { RenewalsJanusComponent } from 'src/app/components/renewals/renewals-janus/renewals-janus.component';
import { clientAdminJanusRoutesNames } from 'src/app/services/mock-data/client-admin-janus-constants/client-admin-janus-constants';
import { ContractorsJanusComponent } from 'src/app/views/admin/contractors-janus/contractors-janus.component';
import { InspectionsJanusComponent } from 'src/app/views/admin/inspections-janus/inspections-janus.component';
import { MeetingsJanusComponent } from 'src/app/views/admin/meetings-janus/meetings-janus.component';
import { SettingsJanusComponent } from 'src/app/views/admin/settings-janus/settings-janus.component';
import { UsersJanusComponent } from 'src/app/views/admin/users-janus/users-janus.component';
import { MapComponent } from 'src/app/views/admin/workflow-applications/workflow-applications-janus/map/map.component';
import { WorkflowApplicationsJanusComponent } from 'src/app/views/admin/workflow-applications/workflow-applications-janus/workflow-applications-janus.component';
import { WorkflowJanusComponent } from 'src/app/views/admin/workflow-janus/workflow-janus.component';
import { ClientAdminJanusComponent } from 'src/app/views/master-views/admin.view/client-admin-janus/client-admin-janus.component';
import { HelpViewJanusComponent } from 'src/app/views/master-views/admin.view/client-admin-janus/help-view-janus/help-view-janus.component';
import { AppViewComponent } from 'src/app/views/master-views/app.view/app.view.component';
import { ReportsJanusComponent } from 'src/app/views/reports-janus/reports-janus.component';
// Start by Juber - 04/02/2026
import { AllContractorsComponent } from 'src/app/views/admin/contractors-janus/all-contractors/all-contractors.component';
import { ContractorTypesComponent } from 'src/app/views/admin/contractors-janus/contractor-type/contractor-types.component';
//end by Juber - - 23/01/2026
//end by Juber - - 23/01/2026
//Start by amisha - 06/02/2026
import { UsersListJanusComponent } from 'src/app/views/admin/users-janus/list/users-list-janus.component';
import { UsersRolesJanusComponent } from 'src/app/views/admin/users-janus/roles/users-roles-janus.component';
import { UsersInviteJanusComponent } from 'src/app/views/admin/users-janus/invite/users-invite-janus.component';
//End by amisha - 06/02/2026
import { FinancialFeesComponent } from 'src/app/views/reports-janus/reports-sub-tab-content/financial-fees/financial-fees.component';
import { ContractorsFeeSummaryComponent } from 'src/app/views/reports-janus/reports-sub-tab-content/contractors-fee-summary/contractors-fee-summary.component';
import { ContractorsSummaryComponent } from 'src/app/views/reports-janus/reports-sub-tab-content/contractors-summary/contractors-summary.component';
import { CustomReportsComponent } from 'src/app/views/reports-janus/reports-sub-tab-content/custom-reports/custom-reports.component';
import { DataSetsComponent } from 'src/app/views/reports-janus/reports-sub-tab-content/data-sets/data-sets.component';
import { FinancialFeeRecipientsComponent } from 'src/app/views/reports-janus/reports-sub-tab-content/financial-fee-recipients/financial-fee-recipients.component';
import { FinancialPaymentsComponent } from 'src/app/views/reports-janus/reports-sub-tab-content/financial-payments/financial-payments.component';
import { ExportWorkflowComponent } from 'src/app/views/reports-janus/reports-sub-tab-content/export-workflow/export-workflow.component';
import { ExportDatasetComponent } from 'src/app/views/reports-janus/reports-sub-tab-content/export-dataset/export-dataset.component';
//end by Juber - - 23/01/2026
import { NewContractorTypeComponent } from 'src/app/views/admin/contractors-janus/new-contractors/new-contractor-type.component';
import { inject } from '@angular/core';
import {
  CompletedApplicationGuard,
  CompletedJanusAdminNewApplicationGuard,
  JanusLayoutGuard,
  ActionGuard
} from 'src/app/services/auth.guard';
import { AppViewShellNavigationGuard } from 'src/app/services/app-view-shell-navigation.guard';
import { Actions } from 'src/app/models';
import { ScheduledExportsEditorJanusComponent } from 'src/app/views/reports-janus/reports-table-header/scheduled-exports-janus/scheduled-exports-editor-janus/scheduled-exports-editor-janus.component';
import { PermitSummaryComponent } from 'src/app/views/reports-janus/reports-sub-tab-content/permits-summary/permits-summary.component';
import { ParcelsJanusComponent } from 'src/app/views/admin/workflow-applications/workflow-applications-janus/parcels-janus/parcels-janus.component';
import { MigrationProcessingCreateComponent } from 'src/app/views/admin/migration-processing-create/migration-processing-create.component';
import { CustomReportInputJanusComponent } from 'src/app/views/reports-janus/reports-sub-tab-content/custom-reports/custom-report-input-janus/custom-report-input-janus.component';
import { NewDatasetComponent } from 'src/app/views/reports-janus/reports-sub-tab-content/data-sets/new-dataset/new-dataset.component';
//end by Juber - - 04/02/2026
// add by furkan 09-03-2026
import { SettingsGeneralComponent } from 'src/app/views/admin/settings-janus/setting-general/settings-general.component';
import { SettingsArchiveDataComponent } from 'src/app/views/admin/settings-janus/settings-archive-data/settings-archive-data.component';
import { SettingsDepartmentsComponent } from 'src/app/views/admin/settings-janus/settings-departments/settings-departments.component';
import { SettingsPreviousSystemComponent } from 'src/app/views/admin/settings-janus/settings-previous-system/settings-previous-system.component';
import { SettingsMapServicesComponent } from 'src/app/views/admin/settings-janus/settings-map-services/settings-map-services.component';
import { SettingsTagsComponent } from 'src/app/views/admin/settings-janus/settings-tags/settings-tags.component';
import { SettingsContactsComponent } from 'src/app/views/admin/settings-janus/settings-contacts/settings-contacts.component';
import { SettingsDataConnectionsComponent } from 'src/app/views/admin/settings-janus/settings-data-connections/settings-data-connections.component';
import { SettingsCustomListsComponent } from 'src/app/views/admin/settings-janus/settings-custom-lists/settings-custom-lists.component';
import { SettingsEmailComponent } from 'src/app/views/admin/settings-janus/settings-email/settings-email.component';
import { SettingsPaymentsComponent } from 'src/app/views/admin/settings-janus/settings-payments/settings-payments.component';
import { InspectionAppConfigurationComponent } from 'src/app/views/admin/client-editor/inspection-app-configuration/inspection-app-configuration.component';
// end by furkan 09-03-2026
//added by furkan - 12-03-2026
import { InspectionsQueueJanusComponent } from 'src/app/views/admin/inspections-janus/inspections-queue-janus/inspections-queue-janus.component';
import { AssignedInspectionsJanusComponent } from 'src/app/views/admin/inspections-janus/assigned-inspections-janus/assigned-inspections-janus.component';
import { InspectionsJanusViewDetailsComponent } from 'src/app/views/admin/inspections-janus/inspections-janus-view-details/inspections-janus-view-details.component';
import { DataTableJanusComponent } from 'src/app/views/admin/workflow-applications/workflow-applications-janus/data-table-janus/data-table-janus.component';
import { BlankWorkflowComponent } from 'src/app/views/admin/workflow-janus/blank-workflow/blank-workflow.component';
import { UseTemplateWorkflowComponent } from 'src/app/views/admin/workflow-janus/use-template-workflow/use-template-workflow.component';
import { WorkflowViewDetailsComponent } from 'src/app/views/admin/workflow-janus/workflow-view-details/workflow-view-details.component';
import { CopyWorkflowSettingsComponent } from 'src/app/components/workflow/copy-workflow-settings/copy-workflow-settings.component';
import { SettingsMigrateWorkflowComponent } from 'src/app/views/admin/settings-janus/settings-migrate-workflow/settings-migrate-workflow.component';
import { SettingsMigrateWorkflowCreateComponent } from 'src/app/views/admin/settings-janus/settings-migrate-workflow/settings-migrate-workflow-create/settings-migrate-workflow-create.component';
import { SettingsMigrateWorkflowDetailComponent } from 'src/app/views/admin/settings-janus/settings-migrate-workflow/settings-migrate-workflow-detail/settings-migrate-workflow-detail.component';
import { SettingsMigrateWorkflowListComponent } from 'src/app/views/admin/settings-janus/settings-migrate-workflow/settings-migrate-workflow-list/settings-migrate-workflow-list.component';
import { ContractorRegistrationMigrationComponent } from 'src/app/views/admin/contractor-registration-migration/contractor-registration-migration.component';
//ended by furkan - 12-03-2026

export const ClientAdminJanusRoutes: Routes = [
  {
    path: clientAdminJanusRoutesNames.root,
    children: [
      {
        path: 'department/:departmentId',
        component: ClientAdminJanusComponent,
        canActivate: [JanusLayoutGuard],
        // Added by Amisha on 2026-06-12.
        // Reason: catch Janus staff shell navigation in one place whenever AppView is open.
        canActivateChild: [AppViewShellNavigationGuard],
        children: [
          {
            path: '',
            redirectTo:
              clientAdminJanusRoutesNames.workflowApplications.routeName,
            pathMatch: 'full'
          },
          {
            path: clientAdminJanusRoutesNames.workflowApplications.routeName,
            component: WorkflowApplicationsJanusComponent,
            children: [
              {
                path: '',
                redirectTo: 'data',
                pathMatch: 'full'
              },
              {
                path: 'data',
                component: DataTableJanusComponent,
                data: {
                  applicationView: 'inline'
                },
                children: [
                  {
                    path: 'application/:applicationId',
                    component: AppViewComponent,
                    canActivate: [
                      (
                        next: ActivatedRouteSnapshot,
                        state: RouterStateSnapshot
                      ) =>
                        inject(
                          CompletedJanusAdminNewApplicationGuard
                        ).canActivate(next, state)
                    ],
                    data: {
                      applicationView: 'overlay'
                    }
                  },
                  {
                    path: 'child-application/:applicationId',
                    component: AppViewComponent,
                    data: {
                      applicationView: 'overlay',
                      type: 'child-application'
                    }
                  }
                ]
              },
              {
                path: 'map',
                component: MapComponent
              },
              {
                path: 'parcels',
                component: ParcelsJanusComponent
              }
            ]
          },
          //Updated by amisha - 18/02/2026 for renewals routes
          {
            path: clientAdminJanusRoutesNames.renewals.routeName,
            component: RenewalsJanusComponent,
            children: [
              {
                path: 'scheduled-export/:componentId',
                component: ScheduledExportsEditorJanusComponent,
                outlet: 'overlay',
                data: {
                  applicationView: 'overlay'
                }
              }
            ]
          },
          {
            // start by Juber - 04/02/2026
            path: clientAdminJanusRoutesNames.contractors.routeName,
            component: ContractorsJanusComponent,
            children: [
              { path: '', redirectTo: 'all', pathMatch: 'full' },
              {
                path: 'all',
                component: AllContractorsComponent,
                data: {
                  applicationView: 'inline'
                },
                children: [
                  // Added by Amisha on 2026-07-21.
                  // Reason: open a newly started contractor registration AppView
                  // inside the Contractors Janus table overlay.
                  {
                    path: 'application/:applicationId',
                    component: AppViewComponent,
                    canActivate: [
                      (
                        next: ActivatedRouteSnapshot,
                        state: RouterStateSnapshot
                      ) =>
                        inject(
                          CompletedJanusAdminNewApplicationGuard
                        ).canActivate(next, state)
                    ],
                    data: {
                      applicationView: 'overlay'
                    }
                  }
                ]
              },
              {
                path: 'scheduled-export/:componentId',
                component: ScheduledExportsEditorJanusComponent,
                outlet: 'overlay',
                data: {
                  applicationView: 'overlay'
                }
              },
              {
                path: 'types',
                component: ContractorTypesComponent,
                children: [
                  {
                    path: 'add',
                    component: NewContractorTypeComponent
                  },
                  {
                    path: 'edit/:contractorTypeId',
                    component: NewContractorTypeComponent,
                    children: [
                      {
                        path: 'application/:applicationId',
                        component: AppViewComponent,
                        data: {
                          applicationView: 'overlay'
                        }
                      }
                    ]
                  },
                  {
                    path: 'scheduled-export/:componentId',
                    component: ScheduledExportsEditorJanusComponent,
                    outlet: 'overlay',
                    data: {
                      applicationView: 'overlay'
                    }
                  }
                ]
              }
              // {
              //   path: 'scheduled-export/:componentId',
              //   component: ScheduledExportsEditorJanusComponent,
              //   data:{
              //     applicationView : 'overlay'
              //   }
              // },
            ]
            // End by Juber - 04/02/2026
          },

          //added by furkan - 12-03-2026
          {
            path: clientAdminJanusRoutesNames.inspections.routeName,
            component: InspectionsJanusComponent,
            children: [
              { path: '', redirectTo: 'list', pathMatch: 'full' },
              {
                path: 'list',
                component: InspectionsQueueJanusComponent,
                children: [
                  {
                    path: 'details/:inspectionId',
                    component: InspectionsJanusViewDetailsComponent,
                    data: { applicationView: 'overlay' }
                  }
                  // {
                  //   path: 'scheduled-export/:componentId',
                  //   component: ScheduledExportsEditorJanusComponent,
                  //   outlet: 'overlay',
                  //   data:{
                  //     applicationView : 'overlay'
                  //   }
                  // },
                ]
              },
              {
                path: 'assignedInspections',
                component: AssignedInspectionsJanusComponent,
                children: [
                  {
                    path: 'details/:inspectionId',
                    component: InspectionsJanusViewDetailsComponent,
                    data: { applicationView: 'overlay' }
                  }
                  // {
                  //   path: 'scheduled-export/:componentId',
                  //   component: ScheduledExportsEditorJanusComponent,
                  //   outlet: 'overlay',
                  //   data:{
                  //     applicationView : 'overlay'
                  //   }
                  // },
                ]
              },
              {
                path: 'scheduled-export/:componentId',
                component: ScheduledExportsEditorJanusComponent,
                outlet: 'overlay',
                data: {
                  applicationView: 'overlay'
                }
              }
            ]
          },
          //ended by furkan - 12-03-2026

          {
            path: clientAdminJanusRoutesNames.reports.routeName,
            component: ReportsJanusComponent,
            children: [
              {
                path: '',
                redirectTo: 'financial',
                pathMatch: 'full'
              },

              // ================= FINANCIAL =================
              {
                path: 'financial',
                children: [
                  { path: '', redirectTo: 'fees', pathMatch: 'full' },
                  {
                    path: 'fees',
                    component: FinancialFeesComponent,
                    children: [
                      {
                        path: 'scheduled-export/:componentId',
                        component: ScheduledExportsEditorJanusComponent,
                        outlet: 'overlay',
                        data: {
                          applicationView: 'overlay'
                        }
                      }
                    ]
                  },
                  {
                    path: 'fee-recipients',
                    component: FinancialFeeRecipientsComponent,
                    children: [
                      {
                        path: 'scheduled-export/:componentId',
                        component: ScheduledExportsEditorJanusComponent,
                        outlet: 'overlay',
                        data: {
                          applicationView: 'overlay'
                        }
                      }
                    ]
                  },
                  {
                    path: 'payments',
                    component: FinancialPaymentsComponent,
                    children: [
                      {
                        path: 'scheduled-export/:componentId',
                        component: ScheduledExportsEditorJanusComponent,
                        outlet: 'overlay',
                        data: {
                          applicationView: 'overlay'
                        }
                      }
                    ]
                  }
                ]
              },

              // ================= CONTRACTORS =================
              {
                path: 'contractor',
                children: [
                  { path: '', redirectTo: 'summary', pathMatch: 'full' },
                  {
                    path: 'summary',
                    component: ContractorsSummaryComponent,
                    children: [
                      {
                        path: 'scheduled-export/:componentId',
                        component: ScheduledExportsEditorJanusComponent,
                        outlet: 'overlay',
                        data: {
                          applicationView: 'overlay'
                        }
                      }
                    ]
                  },
                  {
                    path: 'fee-summary',
                    component: ContractorsFeeSummaryComponent,
                    children: [
                      {
                        path: 'scheduled-export/:componentId',
                        component: ScheduledExportsEditorJanusComponent,
                        outlet: 'overlay',
                        data: {
                          applicationView: 'overlay'
                        }
                      }
                    ]
                  }
                ]
              },

              // ================= PERMITS =================
              {
                path: 'permits',
                children: [
                  { path: '', redirectTo: 'summary', pathMatch: 'full' },
                  {
                    path: 'summary',
                    component: PermitSummaryComponent,
                    children: [
                      {
                        path: 'scheduled-export/:componentId',
                        component: ScheduledExportsEditorJanusComponent,
                        outlet: 'overlay',
                        data: {
                          applicationView: 'overlay'
                        }
                      }
                    ]
                  }
                ]
              },

              // ================= DATA EXPORT ================= ✅ NEW
              {
                path: 'dataexport',
                children: [
                  {
                    path: '',
                    redirectTo: 'export-workflow',
                    pathMatch: 'full'
                  },
                  {
                    path: 'export-workflow',
                    component: ExportWorkflowComponent,
                    children: [
                      {
                        path: 'scheduled-export/:componentId',
                        component: ScheduledExportsEditorJanusComponent,
                        outlet: 'overlay',
                        data: {
                          applicationView: 'overlay'
                        }
                      }
                    ]
                  },
                  {
                    path: 'export-dataset',
                    component: ExportDatasetComponent,
                    children: [
                      {
                        path: 'scheduled-export/:componentId',
                        component: ScheduledExportsEditorJanusComponent,
                        outlet: 'overlay',
                        data: {
                          applicationView: 'overlay'
                        }
                      }
                    ]
                  }
                ]
              },

              // ================= NO SUB-TABS =================
              {
                path: 'custom',
                children: [
                  {
                    path: '',
                    component: CustomReportsComponent
                  },
                  {
                    path: ':reportId',
                    component: CustomReportInputJanusComponent
                  }
                ]
              },
              {
                path: 'datasets',
                children: [
                  {
                    path: '',
                    redirectTo: 'data-sets',
                    pathMatch: 'full'
                  },
                  {
                    path: 'data-sets',
                    component: DataSetsComponent
                  },
                  {
                    path: 'new-dataset',
                    component: NewDatasetComponent
                  }
                ]
              }
            ]
          },
          {
            path: clientAdminJanusRoutesNames.meetings.routeName,
            component: MeetingsJanusComponent
          },
          //Updated by amisha - 06/02/2026 for users routes
          {
            path: clientAdminJanusRoutesNames.users.routeName,
            component: UsersJanusComponent,
            children: [
              {
                path: '',
                redirectTo: 'list',
                pathMatch: 'full'
              },
              {
                path: 'list',
                children: [
                  {
                    path: '',
                    component: UsersListJanusComponent
                  },
                  {
                    path: 'edit/:userId',
                    component: UsersListJanusComponent
                  }
                ]
              },
              {
                path: 'roles',
                children: [
                  {
                    path: '',
                    redirectTo: 'list',
                    pathMatch: 'full'
                  },
                  {
                    path: 'list',
                    component: UsersRolesJanusComponent
                  },
                  {
                    path: 'add',
                    component: UsersRolesJanusComponent
                  },
                  {
                    path: 'edit/:roleId',
                    component: UsersRolesJanusComponent
                  }
                ]
              },

              {
                path: 'invitations',
                children: [
                  {
                    path: '',
                    redirectTo: 'add',
                    pathMatch: 'full'
                  },
                  {
                    path: 'add',
                    component: UsersInviteJanusComponent
                  }
                ]
              }
            ]
          },
          //End by amisha - 06/02/2026 for users routes

          //Added by furkan - 09/03/2026 for settings routes
          {
            path: clientAdminJanusRoutesNames.settings.routeName,
            component: SettingsJanusComponent,
            children: [
              {
                path: '',
                redirectTo: 'general',
                pathMatch: 'full'
              },
              {
                path: 'general',
                component: SettingsGeneralComponent
              },
              {
                path: 'archive-data',
                component: SettingsArchiveDataComponent,
                canActivate: [ActionGuard],
                data: { action: Actions.DO_ANYTHING }
              },
              {
                path: 'departments',
                component: SettingsDepartmentsComponent
              },
              {
                path: 'departments/:id',
                component: SettingsDepartmentsComponent
              },
              {
                path: 'departments/:id/inspection-app-columns',
                component: InspectionAppConfigurationComponent
              },
              {
                path: 'import-previous-system',
                component: SettingsPreviousSystemComponent
              },
              //Added by amisha on 05/25/2026
              {
                path: 'workflow-migration',
                component: SettingsMigrateWorkflowComponent,
                canActivate: [ActionGuard],
                data: {
                  action: Actions.DO_ANYTHING
                },
                children: [
                  {
                    path: '',
                    component: SettingsMigrateWorkflowListComponent
                  },
                  {
                    path: 'create',
                    component: SettingsMigrateWorkflowCreateComponent
                  },
                  {
                    path: ':migrationProcessingId',
                    component: SettingsMigrateWorkflowDetailComponent
                  }
                ]
              },
              {
                path: 'maps',
                children: [
                  {
                    path: '',
                    redirectTo: 'list',
                    pathMatch: 'full'
                  },
                  {
                    path: 'list',
                    component: SettingsMapServicesComponent
                  },
                  {
                    path: 'add',
                    component: SettingsMapServicesComponent
                  },
                  {
                    path: 'edit/:id',
                    component: SettingsMapServicesComponent
                  }
                ]
              },
              {
                path: 'contacts',
                children: [
                  {
                    path: '',
                    redirectTo: 'list',
                    pathMatch: 'full'
                  },
                  {
                    path: 'list',
                    component: SettingsContactsComponent
                  },
                  {
                    path: 'add',
                    component: SettingsContactsComponent
                  },
                  {
                    path: 'edit/:id',
                    component: SettingsContactsComponent
                  }
                ]
              },
              {
                path: 'data',
                children: [
                  {
                    path: '',
                    redirectTo: 'list',
                    pathMatch: 'full'
                  },
                  {
                    path: 'list',
                    component: SettingsDataConnectionsComponent
                  },
                  {
                    path: 'add',
                    component: SettingsDataConnectionsComponent
                  },
                  {
                    path: 'edit/:id',
                    component: SettingsDataConnectionsComponent
                  }
                ]
              },
              {
                path: 'lists',
                children: [
                  {
                    path: '',
                    redirectTo: 'list',
                    pathMatch: 'full'
                  },
                  {
                    path: 'list',
                    component: SettingsCustomListsComponent
                  },
                  {
                    path: 'add',
                    component: SettingsCustomListsComponent
                  },
                  {
                    path: 'edit/:id',
                    component: SettingsCustomListsComponent
                  }
                ]
              },
              {
                path: 'email-settings',
                component: SettingsEmailComponent
              },
              {
                path: 'email-footers',
                component: SettingsEmailComponent
              },
              {
                path: 'tags',
                component: SettingsTagsComponent
              },
              {
                path: 'migrate-contractors',
                component: ContractorRegistrationMigrationComponent,
                canActivate: [ActionGuard],
                data: {
                  action: Actions.DO_ANYTHING
                }
              },
              {
                path: 'payment-settings',
                children: [
                  {
                    path: '',
                    redirectTo: 'payment-accounts/list',
                    pathMatch: 'full'
                  },
                  {
                    path: 'payment-accounts/list',
                    component: SettingsPaymentsComponent
                  },
                  {
                    path: 'payment-accounts/add',
                    component: SettingsPaymentsComponent
                  },
                  {
                    path: 'payment-accounts/edit/:id',
                    component: SettingsPaymentsComponent
                  },
                  {
                    path: 'fee-recipients',
                    component: SettingsPaymentsComponent
                  }
                ]
              }
            ]
          },
          //ended by furkan - 09/03/2026 for settings routes
          {
            path: clientAdminJanusRoutesNames.workflows.routeName,
            children: [
              {
                path: '',
                redirectTo: 'list',
                pathMatch: 'full'
              },
              {
                path: 'list',
                component: WorkflowJanusComponent,
                children: [
                  {
                    path: 'new/blank',
                    component: BlankWorkflowComponent,
                    outlet: 'editWorkflow'
                  },
                  {
                    path: 'new/template',
                    component: UseTemplateWorkflowComponent,
                    outlet: 'modal'
                  },
                  {
                    path: ':id',
                    component: WorkflowViewDetailsComponent,
                    outlet: 'listWorkflowSettings'
                  },
                  {
                    path: ':id',
                    component: BlankWorkflowComponent,
                    outlet: 'editWorkflow'
                  },
                  {
                    path: 'application/:id',
                    component: AppViewComponent,
                    outlet: 'appView'
                  },
                  {
                    path: 'copy/:workflowId',
                    component: CopyWorkflowSettingsComponent,
                    outlet: 'copyModal'
                  }
                ]
              },
              {
                path: 'archive',
                component: WorkflowJanusComponent,
                children: [
                  {
                    path: 'new/blank',
                    component: BlankWorkflowComponent,
                    outlet: 'editWorkflow'
                  },
                  {
                    path: 'new/template',
                    component: UseTemplateWorkflowComponent,
                    outlet: 'modal'
                  },
                  {
                    path: ':id',
                    component: WorkflowViewDetailsComponent,
                    outlet: 'archiveWorkflowSettings'
                  },
                  {
                    path: ':id',
                    component: BlankWorkflowComponent,
                    outlet: 'editWorkflow'
                  }
                ]
              },
              {
                path: 'pending',
                component: WorkflowJanusComponent,
                children: [
                  {
                    path: 'new/blank',
                    component: BlankWorkflowComponent,
                    outlet: 'editWorkflow'
                  },
                  {
                    path: 'new/template',
                    component: UseTemplateWorkflowComponent,
                    outlet: 'modal'
                  },
                  {
                    path: ':id',
                    component: BlankWorkflowComponent,
                    outlet: 'editWorkflow'
                  }
                ]
              }
              // {
              //   path: 'new/blank',
              //   component: BlankWorkflowComponent,
              //   outlet: 'modal'
              // },
              // {
              //   path: 'new/template',
              //   component: UseTemplateWorkflowComponent,
              //   outlet: 'modal'
              // }
            ]
          },
          {
            path: clientAdminJanusRoutesNames.help.routeName,
            component: HelpViewJanusComponent
          },
          {
            path: 'workflow-migration/create',
            component: MigrationProcessingCreateComponent
          }
        ]
      }
    ]
  }
];
